import request from '@/utils/request';


export function optimizationAPI () {
    return {
        // 获取角色组列表
        getRuleList: params => {
            return request ({
                url: '/admin/rule/list',
                method: 'get',
                params,
            });
        },
        addAndEditRule: params => {
            return request ({
                url: '/admin/rule/edit',
                method: 'post',
                data: params,
            });
        },
        getRuleInfo: params => {
            return request ({
                url: `/admin/rule/info?id=${params}`,
                method: 'get',
            });
        },
        delRule: params => {
            return request ({
                url: `/admin/rule/del`,
                method: 'post',
                data: params,
            });
        },
    };
}
